export const even = {
    "uuid": "919dfd37-a076-4d11-9f67-5b2c27f60abc",
    "leadUuid": "52e1685a-7978-48b8-906a-7aed9cb97bc4",
    "loanAmount": 10000,
    "creditCardOffers": [],
    "lifeInsuranceOffers": [],
    "lineOfCreditOffers": [],
    "loanOffers": [{
        "minAmount": null,
        "maxFeeRate": 1.5,
        "maxFeeFixed": 225,
        "prepaymentFee": null,
        "payout": 32.19,
        "minMonthlyPayment": null,
        "originator": {
            "key": "axos",
            "name": "Axos - PL",
            "description": "<span> <ul> <li>We offer unsecured personal loans between $5,000 to $35,000<\/li> <li> Term options include 12, 24, 36, 48, and 60 months (1-5 years)*<\/li> <li>Funding within 2 days of acceptance of final loan offer and deposited directly into checking or savings account<\/li> <\/span><span><li>No collateral required and no pre-payment penalties<\/li> <\/ul> <\/span>",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/s3.amazonaws.com\/images.evenfinancial.com\/logos\/axos\/Axos_Bank_Logo.svg"
            }],
            "disclaimer": "*Example: A $15,000 loan with an Annual Percentage Rate (APR) of 13.25% for 60 months has a payment of $326.06.\n \nCredit is subject to approval. Terms and conditions apply. This is not a commitment to lend. All approvals are subject to underwriting guidelines. Programs, rates, terms, and conditions are subject to change without notice. Restrictions may apply.\n",
            "companyUuid": "289c9611-2766-41b5-877b-0d79488180b0",
            "financialInstitutionUuid": "df8be206-7b49-4410-a364-1891bca6281a"
        },
        "minApr": null,
        "uuid": "ed2c5e91-dde8-4706-8b64-d9bd08af8e50",
        "feeRate": 1.5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": null,
        "maxApr": 8.53,
        "conversionProbability": 0.143046572804451,
        "monthlyPayment": 303.36,
        "terms": null,
        "recommendationScore": 3219,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 303.36,
        "originatorId": null,
        "maxAmount": 15000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/3a53eb6a-ac1b-4683-97cd-1520ad093437",
        "meanApr": 8.53,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 60,
        "meanTotalPayment": 18201.6,
        "preApproved": false,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 18201.6,
        "feeFixed": 225,
        "secured": false,
        "meanMonthlyPayment": 303.36
    }, {
        "minAmount": null,
        "maxFeeRate": 1.5,
        "maxFeeFixed": 225,
        "prepaymentFee": null,
        "payout": 27.43,
        "minMonthlyPayment": null,
        "originator": {
            "key": "axos",
            "name": "Axos - PL",
            "description": "<span> <ul> <li>We offer unsecured personal loans between $5,000 to $35,000<\/li> <li> Term options include 12, 24, 36, 48, and 60 months (1-5 years)*<\/li> <li>Funding within 2 days of acceptance of final loan offer and deposited directly into checking or savings account<\/li> <\/span><span><li>No collateral required and no pre-payment penalties<\/li> <\/ul> <\/span>",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/s3.amazonaws.com\/images.evenfinancial.com\/logos\/axos\/Axos_Bank_Logo.svg"
            }],
            "disclaimer": "*Example: A $15,000 loan with an Annual Percentage Rate (APR) of 13.25% for 60 months has a payment of $326.06.\n \nCredit is subject to approval. Terms and conditions apply. This is not a commitment to lend. All approvals are subject to underwriting guidelines. Programs, rates, terms, and conditions are subject to change without notice. Restrictions may apply.\n",
            "companyUuid": "289c9611-2766-41b5-877b-0d79488180b0",
            "financialInstitutionUuid": "df8be206-7b49-4410-a364-1891bca6281a"
        },
        "minApr": null,
        "uuid": "ce6d2876-435a-4454-befa-8efccf412d74",
        "feeRate": 1.5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": null,
        "maxApr": 8.68,
        "conversionProbability": 0.12192930281162262,
        "monthlyPayment": 365.42,
        "terms": null,
        "recommendationScore": 2743,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 365.42,
        "originatorId": null,
        "maxAmount": 15000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/2f94a23e-c005-4031-b171-e49102d06cf6",
        "meanApr": 8.68,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 48,
        "meanTotalPayment": 17540.16,
        "preApproved": false,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 17540.16,
        "feeFixed": 225,
        "secured": false,
        "meanMonthlyPayment": 365.42
    }, {
        "minAmount": null,
        "maxFeeRate": 1.5,
        "maxFeeFixed": 225,
        "prepaymentFee": null,
        "payout": 22.74,
        "minMonthlyPayment": null,
        "originator": {
            "key": "axos",
            "name": "Axos - PL",
            "description": "<span> <ul> <li>We offer unsecured personal loans between $5,000 to $35,000<\/li> <li> Term options include 12, 24, 36, 48, and 60 months (1-5 years)*<\/li> <li>Funding within 2 days of acceptance of final loan offer and deposited directly into checking or savings account<\/li> <\/span><span><li>No collateral required and no pre-payment penalties<\/li> <\/ul> <\/span>",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/s3.amazonaws.com\/images.evenfinancial.com\/logos\/axos\/Axos_Bank_Logo.svg"
            }],
            "disclaimer": "*Example: A $15,000 loan with an Annual Percentage Rate (APR) of 13.25% for 60 months has a payment of $326.06.\n \nCredit is subject to approval. Terms and conditions apply. This is not a commitment to lend. All approvals are subject to underwriting guidelines. Programs, rates, terms, and conditions are subject to change without notice. Restrictions may apply.\n",
            "companyUuid": "289c9611-2766-41b5-877b-0d79488180b0",
            "financialInstitutionUuid": "df8be206-7b49-4410-a364-1891bca6281a"
        },
        "minApr": null,
        "uuid": "012d953e-d59e-466c-a54e-2c759a7ebaab",
        "feeRate": 1.5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": null,
        "maxApr": 8.92,
        "conversionProbability": 0.10107960551977158,
        "monthlyPayment": 469.28,
        "terms": null,
        "recommendationScore": 2274,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 469.28,
        "originatorId": null,
        "maxAmount": 15000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/c96f8278-9ca6-4c64-9652-16da208790be",
        "meanApr": 8.92,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 36,
        "meanTotalPayment": 16894.08,
        "preApproved": false,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 16894.08,
        "feeFixed": 225,
        "secured": false,
        "meanMonthlyPayment": 469.28
    }, {
        "minAmount": null,
        "maxFeeRate": 1.5,
        "maxFeeFixed": 150,
        "prepaymentFee": null,
        "payout": 22.12,
        "minMonthlyPayment": null,
        "originator": {
            "key": "axos",
            "name": "Axos - PL",
            "description": "<span> <ul> <li>We offer unsecured personal loans between $5,000 to $35,000<\/li> <li> Term options include 12, 24, 36, 48, and 60 months (1-5 years)*<\/li> <li>Funding within 2 days of acceptance of final loan offer and deposited directly into checking or savings account<\/li> <\/span><span><li>No collateral required and no pre-payment penalties<\/li> <\/ul> <\/span>",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/s3.amazonaws.com\/images.evenfinancial.com\/logos\/axos\/Axos_Bank_Logo.svg"
            }],
            "disclaimer": "*Example: A $15,000 loan with an Annual Percentage Rate (APR) of 13.25% for 60 months has a payment of $326.06.\n \nCredit is subject to approval. Terms and conditions apply. This is not a commitment to lend. All approvals are subject to underwriting guidelines. Programs, rates, terms, and conditions are subject to change without notice. Restrictions may apply.\n",
            "companyUuid": "289c9611-2766-41b5-877b-0d79488180b0",
            "financialInstitutionUuid": "df8be206-7b49-4410-a364-1891bca6281a"
        },
        "minApr": null,
        "uuid": "85e341a9-f949-4ee6-8561-6efc2320fccc",
        "feeRate": 1.5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": null,
        "maxApr": 8.53,
        "conversionProbability": 0.14746908843517303,
        "monthlyPayment": 202.24,
        "terms": null,
        "recommendationScore": 2212,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 202.24,
        "originatorId": null,
        "maxAmount": 10000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/20c24b4a-9a36-4e18-b4e5-9dea2ef984c0",
        "meanApr": 8.53,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 60,
        "meanTotalPayment": 12134.4,
        "preApproved": false,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 12134.4,
        "feeFixed": 150,
        "secured": false,
        "meanMonthlyPayment": 202.24
    }, {
        "minAmount": null,
        "maxFeeRate": 1.5,
        "maxFeeFixed": 150,
        "prepaymentFee": null,
        "payout": 21.77,
        "minMonthlyPayment": null,
        "originator": {
            "key": "axos",
            "name": "Axos - PL",
            "description": "<span> <ul> <li>We offer unsecured personal loans between $5,000 to $35,000<\/li> <li> Term options include 12, 24, 36, 48, and 60 months (1-5 years)*<\/li> <li>Funding within 2 days of acceptance of final loan offer and deposited directly into checking or savings account<\/li> <\/span><span><li>No collateral required and no pre-payment penalties<\/li> <\/ul> <\/span>",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/s3.amazonaws.com\/images.evenfinancial.com\/logos\/axos\/Axos_Bank_Logo.svg"
            }],
            "disclaimer": "*Example: A $15,000 loan with an Annual Percentage Rate (APR) of 13.25% for 60 months has a payment of $326.06.\n \nCredit is subject to approval. Terms and conditions apply. This is not a commitment to lend. All approvals are subject to underwriting guidelines. Programs, rates, terms, and conditions are subject to change without notice. Restrictions may apply.\n",
            "companyUuid": "289c9611-2766-41b5-877b-0d79488180b0",
            "financialInstitutionUuid": "df8be206-7b49-4410-a364-1891bca6281a"
        },
        "minApr": null,
        "uuid": "4e7206fa-4be6-4963-bd1c-86b932e14a7c",
        "feeRate": 1.5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": null,
        "maxApr": 8.68,
        "conversionProbability": 0.14512020349502563,
        "monthlyPayment": 243.61,
        "terms": null,
        "recommendationScore": 2177,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 243.61,
        "originatorId": null,
        "maxAmount": 10000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/db254002-4380-4edd-ad22-23f9293d390f",
        "meanApr": 8.68,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 48,
        "meanTotalPayment": 11693.28,
        "preApproved": false,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 11693.28,
        "feeFixed": 150,
        "secured": false,
        "meanMonthlyPayment": 243.61
    }, {
        "minAmount": null,
        "maxFeeRate": 5,
        "maxFeeFixed": null,
        "prepaymentFee": null,
        "payout": 20.32,
        "minMonthlyPayment": null,
        "originator": {
            "key": "freedom-plus",
            "name": "FreedomPlus",
            "description": "Personal loans from $10,000 to $50,000.",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/aff-tag.evenfinancial.com\/images\/freedomplus\/freedom_plus_120.png"
            }],
            "disclaimer": "All loans available through FreedomPlus.com are made by Cross River Bank, a New Jersey State Chartered Commercial Bank, Member FDIC, Equal Housing Lender. All loan and rate terms are subject to eligibility restrictions, application review, credit score, loan amount, loan term, lender approval, and credit usage and history. Eligibility for a loan is not guaranteed. Loans are not available to residents of all states \u2013 please call a FreedomPlus representative for further details. The following limitations, in addition to others, shall apply: FreedomPlus does not arrange loans in: (i) Arizona under $10,500; (ii) Massachusetts under $6,500, (iii) Ohio under $5,500, and (iv) Georgia under $3,500. Repayment periods range from 24 to 60 months. The range of APRs on loans made available through FreedomPlus is 6.99% to a maximum of 29.99%. APR. The APR calculation includes all applicable fees, including the loan origination fee. For Example, a four year $20,000 loan with an interest rate of 15.49% and corresponding APR of 18.34% would have an estimated monthly payment of $561.60 and a total cost payable of $7,948.13. To qualify for a 6.99% APR loan, a borrower will need excellent credit on a loan for an amount less than $12,000.00, and with a term equal to 24 months. Adding a co-borrower with sufficient income; using at least eighty-five percent (85%) of the loan proceeds to directly pay off qualifying existing debt; or showing proof of sufficient retirement savings, could help you also qualify for the lowest rate available.",
            "companyUuid": "aa80f86b-b438-4173-a0ff-4e2a273c3d5b",
            "financialInstitutionUuid": "a8b70d64-f0d0-4150-828d-22a187d77cd7"
        },
        "minApr": null,
        "uuid": "407313ab-8428-42cc-a958-fe828c6761ba",
        "feeRate": 5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": 1.38,
        "maxApr": 15.81,
        "conversionProbability": 0.16929855942726135,
        "monthlyPayment": 230.05,
        "terms": null,
        "recommendationScore": 2032,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 230.05,
        "originatorId": null,
        "maxAmount": 10000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/dce790b5-8aaa-4419-951d-02f125a37b46",
        "meanApr": 15.81,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 60,
        "meanTotalPayment": 13803,
        "preApproved": true,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 13803,
        "feeFixed": null,
        "secured": false,
        "meanMonthlyPayment": 230.05
    }, {
        "minAmount": null,
        "maxFeeRate": 1.5,
        "maxFeeFixed": 150,
        "prepaymentFee": null,
        "payout": 20.22,
        "minMonthlyPayment": null,
        "originator": {
            "key": "axos",
            "name": "Axos - PL",
            "description": "<span> <ul> <li>We offer unsecured personal loans between $5,000 to $35,000<\/li> <li> Term options include 12, 24, 36, 48, and 60 months (1-5 years)*<\/li> <li>Funding within 2 days of acceptance of final loan offer and deposited directly into checking or savings account<\/li> <\/span><span><li>No collateral required and no pre-payment penalties<\/li> <\/ul> <\/span>",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/s3.amazonaws.com\/images.evenfinancial.com\/logos\/axos\/Axos_Bank_Logo.svg"
            }],
            "disclaimer": "*Example: A $15,000 loan with an Annual Percentage Rate (APR) of 13.25% for 60 months has a payment of $326.06.\n \nCredit is subject to approval. Terms and conditions apply. This is not a commitment to lend. All approvals are subject to underwriting guidelines. Programs, rates, terms, and conditions are subject to change without notice. Restrictions may apply.\n",
            "companyUuid": "289c9611-2766-41b5-877b-0d79488180b0",
            "financialInstitutionUuid": "df8be206-7b49-4410-a364-1891bca6281a"
        },
        "minApr": null,
        "uuid": "c390e7ee-f679-4523-a5c7-d242dcfaf33c",
        "feeRate": 1.5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": null,
        "maxApr": 8.92,
        "conversionProbability": 0.1347668617963791,
        "monthlyPayment": 312.86,
        "terms": null,
        "recommendationScore": 2022,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 312.86,
        "originatorId": null,
        "maxAmount": 10000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/8dcc5ca0-da4d-41d1-b953-a7585c856630",
        "meanApr": 8.92,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 36,
        "meanTotalPayment": 11262.96,
        "preApproved": false,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 11262.96,
        "feeFixed": 150,
        "secured": false,
        "meanMonthlyPayment": 312.86
    }, {
        "minAmount": null,
        "maxFeeRate": 5,
        "maxFeeFixed": null,
        "prepaymentFee": null,
        "payout": 20,
        "minMonthlyPayment": null,
        "originator": {
            "key": "freedom-plus",
            "name": "FreedomPlus",
            "description": "Personal loans from $10,000 to $50,000.",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/aff-tag.evenfinancial.com\/images\/freedomplus\/freedom_plus_120.png"
            }],
            "disclaimer": "All loans available through FreedomPlus.com are made by Cross River Bank, a New Jersey State Chartered Commercial Bank, Member FDIC, Equal Housing Lender. All loan and rate terms are subject to eligibility restrictions, application review, credit score, loan amount, loan term, lender approval, and credit usage and history. Eligibility for a loan is not guaranteed. Loans are not available to residents of all states \u2013 please call a FreedomPlus representative for further details. The following limitations, in addition to others, shall apply: FreedomPlus does not arrange loans in: (i) Arizona under $10,500; (ii) Massachusetts under $6,500, (iii) Ohio under $5,500, and (iv) Georgia under $3,500. Repayment periods range from 24 to 60 months. The range of APRs on loans made available through FreedomPlus is 6.99% to a maximum of 29.99%. APR. The APR calculation includes all applicable fees, including the loan origination fee. For Example, a four year $20,000 loan with an interest rate of 15.49% and corresponding APR of 18.34% would have an estimated monthly payment of $561.60 and a total cost payable of $7,948.13. To qualify for a 6.99% APR loan, a borrower will need excellent credit on a loan for an amount less than $12,000.00, and with a term equal to 24 months. Adding a co-borrower with sufficient income; using at least eighty-five percent (85%) of the loan proceeds to directly pay off qualifying existing debt; or showing proof of sufficient retirement savings, could help you also qualify for the lowest rate available.",
            "companyUuid": "aa80f86b-b438-4173-a0ff-4e2a273c3d5b",
            "financialInstitutionUuid": "a8b70d64-f0d0-4150-828d-22a187d77cd7"
        },
        "minApr": null,
        "uuid": "cf262ffb-822d-4dae-bc06-18c3342fd685",
        "feeRate": 5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": 1.38,
        "maxApr": 15.8,
        "conversionProbability": 0.16666994988918304,
        "monthlyPayment": 268.23,
        "terms": null,
        "recommendationScore": 2000,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 268.23,
        "originatorId": null,
        "maxAmount": 10000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/0a87b231-3758-451a-8405-7afb55f4b985",
        "meanApr": 15.8,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 48,
        "meanTotalPayment": 12875.04,
        "preApproved": true,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 12875.04,
        "feeFixed": null,
        "secured": false,
        "meanMonthlyPayment": 268.23
    }, {
        "minAmount": null,
        "maxFeeRate": 5,
        "maxFeeFixed": null,
        "prepaymentFee": null,
        "payout": 18.61,
        "minMonthlyPayment": null,
        "originator": {
            "key": "freedom-plus",
            "name": "FreedomPlus",
            "description": "Personal loans from $10,000 to $50,000.",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/aff-tag.evenfinancial.com\/images\/freedomplus\/freedom_plus_120.png"
            }],
            "disclaimer": "All loans available through FreedomPlus.com are made by Cross River Bank, a New Jersey State Chartered Commercial Bank, Member FDIC, Equal Housing Lender. All loan and rate terms are subject to eligibility restrictions, application review, credit score, loan amount, loan term, lender approval, and credit usage and history. Eligibility for a loan is not guaranteed. Loans are not available to residents of all states \u2013 please call a FreedomPlus representative for further details. The following limitations, in addition to others, shall apply: FreedomPlus does not arrange loans in: (i) Arizona under $10,500; (ii) Massachusetts under $6,500, (iii) Ohio under $5,500, and (iv) Georgia under $3,500. Repayment periods range from 24 to 60 months. The range of APRs on loans made available through FreedomPlus is 6.99% to a maximum of 29.99%. APR. The APR calculation includes all applicable fees, including the loan origination fee. For Example, a four year $20,000 loan with an interest rate of 15.49% and corresponding APR of 18.34% would have an estimated monthly payment of $561.60 and a total cost payable of $7,948.13. To qualify for a 6.99% APR loan, a borrower will need excellent credit on a loan for an amount less than $12,000.00, and with a term equal to 24 months. Adding a co-borrower with sufficient income; using at least eighty-five percent (85%) of the loan proceeds to directly pay off qualifying existing debt; or showing proof of sufficient retirement savings, could help you also qualify for the lowest rate available.",
            "companyUuid": "aa80f86b-b438-4173-a0ff-4e2a273c3d5b",
            "financialInstitutionUuid": "a8b70d64-f0d0-4150-828d-22a187d77cd7"
        },
        "minApr": null,
        "uuid": "93feb0a3-6c48-4680-a223-e983a734ed1a",
        "feeRate": 5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": 1.38,
        "maxApr": 15.88,
        "conversionProbability": 0.15505804121494293,
        "monthlyPayment": 336.89,
        "terms": null,
        "recommendationScore": 1861,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 336.89,
        "originatorId": null,
        "maxAmount": 10000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/60b5789c-3bd7-4cd7-8651-a4e7577462c5",
        "meanApr": 15.88,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 36,
        "meanTotalPayment": 12128.04,
        "preApproved": true,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 12128.04,
        "feeFixed": null,
        "secured": false,
        "meanMonthlyPayment": 336.89
    }, {
        "minAmount": null,
        "maxFeeRate": 5,
        "maxFeeFixed": null,
        "prepaymentFee": null,
        "payout": 17.75,
        "minMonthlyPayment": null,
        "originator": {
            "key": "freedom-plus",
            "name": "FreedomPlus",
            "description": "Personal loans from $10,000 to $50,000.",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/aff-tag.evenfinancial.com\/images\/freedomplus\/freedom_plus_120.png"
            }],
            "disclaimer": "All loans available through FreedomPlus.com are made by Cross River Bank, a New Jersey State Chartered Commercial Bank, Member FDIC, Equal Housing Lender. All loan and rate terms are subject to eligibility restrictions, application review, credit score, loan amount, loan term, lender approval, and credit usage and history. Eligibility for a loan is not guaranteed. Loans are not available to residents of all states \u2013 please call a FreedomPlus representative for further details. The following limitations, in addition to others, shall apply: FreedomPlus does not arrange loans in: (i) Arizona under $10,500; (ii) Massachusetts under $6,500, (iii) Ohio under $5,500, and (iv) Georgia under $3,500. Repayment periods range from 24 to 60 months. The range of APRs on loans made available through FreedomPlus is 6.99% to a maximum of 29.99%. APR. The APR calculation includes all applicable fees, including the loan origination fee. For Example, a four year $20,000 loan with an interest rate of 15.49% and corresponding APR of 18.34% would have an estimated monthly payment of $561.60 and a total cost payable of $7,948.13. To qualify for a 6.99% APR loan, a borrower will need excellent credit on a loan for an amount less than $12,000.00, and with a term equal to 24 months. Adding a co-borrower with sufficient income; using at least eighty-five percent (85%) of the loan proceeds to directly pay off qualifying existing debt; or showing proof of sufficient retirement savings, could help you also qualify for the lowest rate available.",
            "companyUuid": "aa80f86b-b438-4173-a0ff-4e2a273c3d5b",
            "financialInstitutionUuid": "a8b70d64-f0d0-4150-828d-22a187d77cd7"
        },
        "minApr": null,
        "uuid": "2f79a993-f70d-402f-ad00-f2365f318e56",
        "feeRate": 5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": 1.38,
        "maxApr": 7.98,
        "conversionProbability": 0.14791306853294373,
        "monthlyPayment": 443.16,
        "terms": null,
        "recommendationScore": 1775,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 443.16,
        "originatorId": null,
        "maxAmount": 10000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/56629d4a-3b37-4f52-92a4-028547c1b6ce",
        "meanApr": 7.98,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 24,
        "meanTotalPayment": 10635.84,
        "preApproved": true,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 10635.84,
        "feeFixed": null,
        "secured": false,
        "meanMonthlyPayment": 443.16
    }, {
        "minAmount": null,
        "maxFeeRate": 5,
        "maxFeeFixed": 500,
        "prepaymentFee": null,
        "payout": 17.61,
        "minMonthlyPayment": null,
        "originator": {
            "key": "oneMainDirect",
            "name": "OneMain",
            "description": "<span> <ul> <li>100+ years in business and A+ BBB rating<\/li> <li>Clear terms with no prepayment penalties<\/li> <li>Loan decisions as quickly as 1 hour<\/li>  <li>Apply online, by phone or at your local branch<\/li> <\/ul> <\/span>",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/images.evenfinancial.com\/logos\/onemain\/onemainfinancial_120.png"
            }],
            "disclaimer": "You must apply for this offer and continue to meet the criteria used to select you for this offer. Loan approval and actual loan terms depend on your ability to meet our credit standards (including a responsible credit history, sufficient income after monthly expenses, and availability of collateral). OneMain charges origination fees. Depending on the state where you open your loan, the origination fee may be either a flat amount or a percentage of your loan amount. Flat fee amounts vary by state, ranging from $25 to $400. Percentage-based fees vary by state ranging from 1% to 10% of your loan amount subject to certain state limits on the fee amount. Maximum APR is 35.99%, subject to state restrictions. APRs are generally higher on loans not secured by a vehicle. Loan proceeds cannot be used for postsecondary educational expenses as defined by the CFPB\u2019s Regulation Z such as college, university or vocational expenses; for any business or commercial purpose; to purchase securities; or for gambling or illegal purposes. Current OneMain Customers: The above offer assumes that you do not have a current loan with OneMain or one of its affiliates. If you apply for the offer, a OneMain representative will discuss options available for current customers. Additional conditions for secured loans: Secured loans require a first lien on a motor vehicle that meets our value requirements, titled in your name with valid insurance. Active duty military, their spouse or dependents covered by the Military Lending Act may not pledge any vehicle as collateral. If you are covered by the Military Lending Act, you are not eligible for secured offers.",
            "companyUuid": "b5fb1488-8617-4344-86a9-02f5c4008c17",
            "financialInstitutionUuid": "535fbee2-20e8-4ea8-8546-cf7f3b9b44ff"
        },
        "minApr": null,
        "uuid": "48a05b83-7181-432e-8100-3cac93dc541b",
        "feeRate": 5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": null,
        "maxApr": 13.99,
        "conversionProbability": 0.10675463813112371,
        "monthlyPayment": 232.61,
        "terms": null,
        "recommendationScore": 1761,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 232.61,
        "originatorId": null,
        "maxAmount": 10000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/5082f862-ace1-409e-944d-778ffcc7b6dd",
        "meanApr": 13.99,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 60,
        "meanTotalPayment": 13956.6,
        "preApproved": false,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 13956.6,
        "feeFixed": 500,
        "secured": false,
        "meanMonthlyPayment": 232.61
    }, {
        "minAmount": null,
        "maxFeeRate": 5,
        "maxFeeFixed": 600,
        "prepaymentFee": null,
        "payout": 17.5,
        "minMonthlyPayment": null,
        "originator": {
            "key": "oneMainDirect",
            "name": "OneMain",
            "description": "<span> <ul> <li>100+ years in business and A+ BBB rating<\/li> <li>Clear terms with no prepayment penalties<\/li> <li>Loan decisions as quickly as 1 hour<\/li>  <li>Apply online, by phone or at your local branch<\/li> <\/ul> <\/span>",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/images.evenfinancial.com\/logos\/onemain\/onemainfinancial_120.png"
            }],
            "disclaimer": "You must apply for this offer and continue to meet the criteria used to select you for this offer. Loan approval and actual loan terms depend on your ability to meet our credit standards (including a responsible credit history, sufficient income after monthly expenses, and availability of collateral). OneMain charges origination fees. Depending on the state where you open your loan, the origination fee may be either a flat amount or a percentage of your loan amount. Flat fee amounts vary by state, ranging from $25 to $400. Percentage-based fees vary by state ranging from 1% to 10% of your loan amount subject to certain state limits on the fee amount. Maximum APR is 35.99%, subject to state restrictions. APRs are generally higher on loans not secured by a vehicle. Loan proceeds cannot be used for postsecondary educational expenses as defined by the CFPB\u2019s Regulation Z such as college, university or vocational expenses; for any business or commercial purpose; to purchase securities; or for gambling or illegal purposes. Current OneMain Customers: The above offer assumes that you do not have a current loan with OneMain or one of its affiliates. If you apply for the offer, a OneMain representative will discuss options available for current customers. Additional conditions for secured loans: Secured loans require a first lien on a motor vehicle that meets our value requirements, titled in your name with valid insurance. Active duty military, their spouse or dependents covered by the Military Lending Act may not pledge any vehicle as collateral. If you are covered by the Military Lending Act, you are not eligible for secured offers.",
            "companyUuid": "b5fb1488-8617-4344-86a9-02f5c4008c17",
            "financialInstitutionUuid": "535fbee2-20e8-4ea8-8546-cf7f3b9b44ff"
        },
        "minApr": null,
        "uuid": "3264e1a9-0476-4514-82e8-1637d54d04af",
        "feeRate": 5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": null,
        "maxApr": 13.99,
        "conversionProbability": 0.08839907439127064,
        "monthlyPayment": 279.13,
        "terms": null,
        "recommendationScore": 1750,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 279.13,
        "originatorId": null,
        "maxAmount": 12000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/1c33e7e4-6d02-42cd-b728-f0064c7a7691",
        "meanApr": 13.99,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 60,
        "meanTotalPayment": 16747.8,
        "preApproved": false,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 16747.8,
        "feeFixed": 600,
        "secured": false,
        "meanMonthlyPayment": 279.13
    }, {
        "minAmount": null,
        "maxFeeRate": 5,
        "maxFeeFixed": 500,
        "prepaymentFee": null,
        "payout": 16,
        "minMonthlyPayment": null,
        "originator": {
            "key": "oneMainDirect",
            "name": "OneMain",
            "description": "<span> <ul> <li>100+ years in business and A+ BBB rating<\/li> <li>Clear terms with no prepayment penalties<\/li> <li>Loan decisions as quickly as 1 hour<\/li>  <li>Apply online, by phone or at your local branch<\/li> <\/ul> <\/span>",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/images.evenfinancial.com\/logos\/onemain\/onemainfinancial_120.png"
            }],
            "disclaimer": "You must apply for this offer and continue to meet the criteria used to select you for this offer. Loan approval and actual loan terms depend on your ability to meet our credit standards (including a responsible credit history, sufficient income after monthly expenses, and availability of collateral). OneMain charges origination fees. Depending on the state where you open your loan, the origination fee may be either a flat amount or a percentage of your loan amount. Flat fee amounts vary by state, ranging from $25 to $400. Percentage-based fees vary by state ranging from 1% to 10% of your loan amount subject to certain state limits on the fee amount. Maximum APR is 35.99%, subject to state restrictions. APRs are generally higher on loans not secured by a vehicle. Loan proceeds cannot be used for postsecondary educational expenses as defined by the CFPB\u2019s Regulation Z such as college, university or vocational expenses; for any business or commercial purpose; to purchase securities; or for gambling or illegal purposes. Current OneMain Customers: The above offer assumes that you do not have a current loan with OneMain or one of its affiliates. If you apply for the offer, a OneMain representative will discuss options available for current customers. Additional conditions for secured loans: Secured loans require a first lien on a motor vehicle that meets our value requirements, titled in your name with valid insurance. Active duty military, their spouse or dependents covered by the Military Lending Act may not pledge any vehicle as collateral. If you are covered by the Military Lending Act, you are not eligible for secured offers.",
            "companyUuid": "b5fb1488-8617-4344-86a9-02f5c4008c17",
            "financialInstitutionUuid": "535fbee2-20e8-4ea8-8546-cf7f3b9b44ff"
        },
        "minApr": null,
        "uuid": "7e0756a1-a2ea-4af2-977e-c78689bd5794",
        "feeRate": 5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": null,
        "maxApr": 13.99,
        "conversionProbability": 0.09699674451950466,
        "monthlyPayment": 341.72,
        "terms": null,
        "recommendationScore": 1600,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 341.72,
        "originatorId": null,
        "maxAmount": 10000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/161fa842-f044-40bf-ace2-948f1b385769",
        "meanApr": 13.99,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 36,
        "meanTotalPayment": 12301.92,
        "preApproved": false,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 12301.92,
        "feeFixed": 500,
        "secured": false,
        "meanMonthlyPayment": 341.72
    }, {
        "minAmount": null,
        "maxFeeRate": 5,
        "maxFeeFixed": 600,
        "prepaymentFee": null,
        "payout": 13.71,
        "minMonthlyPayment": null,
        "originator": {
            "key": "oneMainDirect",
            "name": "OneMain",
            "description": "<span> <ul> <li>100+ years in business and A+ BBB rating<\/li> <li>Clear terms with no prepayment penalties<\/li> <li>Loan decisions as quickly as 1 hour<\/li>  <li>Apply online, by phone or at your local branch<\/li> <\/ul> <\/span>",
            "images": [{
                "sizeKey": "120x40",
                "url": "https:\/\/images.evenfinancial.com\/logos\/onemain\/onemainfinancial_120.png"
            }],
            "disclaimer": "You must apply for this offer and continue to meet the criteria used to select you for this offer. Loan approval and actual loan terms depend on your ability to meet our credit standards (including a responsible credit history, sufficient income after monthly expenses, and availability of collateral). OneMain charges origination fees. Depending on the state where you open your loan, the origination fee may be either a flat amount or a percentage of your loan amount. Flat fee amounts vary by state, ranging from $25 to $400. Percentage-based fees vary by state ranging from 1% to 10% of your loan amount subject to certain state limits on the fee amount. Maximum APR is 35.99%, subject to state restrictions. APRs are generally higher on loans not secured by a vehicle. Loan proceeds cannot be used for postsecondary educational expenses as defined by the CFPB\u2019s Regulation Z such as college, university or vocational expenses; for any business or commercial purpose; to purchase securities; or for gambling or illegal purposes. Current OneMain Customers: The above offer assumes that you do not have a current loan with OneMain or one of its affiliates. If you apply for the offer, a OneMain representative will discuss options available for current customers. Additional conditions for secured loans: Secured loans require a first lien on a motor vehicle that meets our value requirements, titled in your name with valid insurance. Active duty military, their spouse or dependents covered by the Military Lending Act may not pledge any vehicle as collateral. If you are covered by the Military Lending Act, you are not eligible for secured offers.",
            "companyUuid": "b5fb1488-8617-4344-86a9-02f5c4008c17",
            "financialInstitutionUuid": "535fbee2-20e8-4ea8-8546-cf7f3b9b44ff"
        },
        "minApr": null,
        "uuid": "1942ad70-36e4-466c-bfb6-f13c8312dfa2",
        "feeRate": 5,
        "productSubType": "personal_loan",
        "aprDescription": "Fixed APR",
        "minFeeRate": null,
        "maxApr": 13.99,
        "conversionProbability": 0.06922656480598681,
        "monthlyPayment": 410.06,
        "terms": null,
        "recommendationScore": 1371,
        "productSubTypeDisclaimer": null,
        "monthlyPaymentDescription": "Est. Monthly Payment",
        "maxMonthlyPayment": 410.06,
        "originatorId": null,
        "maxAmount": 12000,
        "allowPrepayment": false,
        "termUnit": "month",
        "productType": "loan",
        "coApplicant": false,
        "preQualified": true,
        "displayTermUnit": null,
        "sponsored": false,
        "url": "https:\/\/offers.evenfinancial.com\/ref\/d1cc44d5-e8c5-49b9-b08c-2bb405976358",
        "meanApr": 13.99,
        "minFeeFixed": null,
        "aprType": "fixed",
        "termLength": 36,
        "meanTotalPayment": 14762.16,
        "preApproved": false,
        "termDescription": "Term of Loan",
        "minTotalPayment": null,
        "maxTotalPayment": 14762.16,
        "feeFixed": 600,
        "secured": false,
        "meanMonthlyPayment": 410.06
    }],
    "mortgageOffers": [],
    "savingsOffers": [],
    "specialOffers": [],
    "pendingOriginators": [],
    "pendingResponses": []
}
